module.exports = __webpack_public_path__ + "static/fav-white-daff9417eda94e2a18e92c912edd3f9d.png";